import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MonthlySummaryComponent } from '../dms/report-monthly/monthly.component';
import { IdexService } from '../idex.service';
import { RegisterSignatureComponent } from 'app/e-signature/register-signature/register-signature.component';
import { TranslateService } from '@ngx-translate/core';
import { RegisterEtaxComponent } from 'app/account/register-etax/register-etax.component';
import { RegisterCompanyDialogComponent } from 'app/account/register-company-dialog/register-company-dialog.component';
import { NumeralPipe } from 'app/shared/numeral.pipe';
import { PdpaAgreementComponent } from 'app/shared/pdpa-agreement/pdpa-agreement.component';
import {AppComponent} from "../app.component";
import { DatePipe } from '@angular/common';

declare let Chart: any;
declare let EnjoyHint: any;

@Component({
   selector: 'app-dashboard',
   templateUrl: './dashboard.component.html',
   styleUrls: ['./dashboard.component.css', '../../assets/font_stylesheet.css']
})
export class DashboardComponent implements OnInit {
   data_year: any;
   user: any;
   company: string;
   status: string;
   used: number;
   quota: number;
   percentUsed = '0%';
   transactionsLoaded = false;
   year: number;
   private pieChart: any;
   private _isFirstSingIn = false;
   private lineChart: any;
   sell: any;
   buy: any;
   fNameValue: any;
   lNameValue: any;
   signatureId: string;
   initialId: string;
   imageSignaturePreview = '';
   imageInitializePreview = '';
   hasSignature: any;
   hasInitial: any;
   errorMessage: string;
   sumNeedSign: number;
   sumWaitOther: number;
   sumSignedDoc: number;
   th: boolean;
   year_param: {};
   businessEtax: any;
   includeName: any;
   includeDate: any;
   includeNameInit: any;
   includeDateInit: any;
   isAcceptEkyc = false;
   isAcceptNdid = false;
   spacePercent = 0;
   taskPercent = 0;
   quotaTask = 0;
   countTask = 0;
   unlimitTask = false;
   unlimitSpace = false;
   spaceColor = 'primary';
   taskColor = 'primary';
   currentDate: Date;
   @ViewChild('canvasOriginal', { static: true }) public canvasOriginal: ElementRef;
   @ViewChild('canvasPatternTmp', { static: true }) public canvasPatternTmp: ElementRef;

   constructor(public dialog: MatDialog, public service: IdexService, private numeral: NumeralPipe,
               public router: Router, public translate: TranslateService, private app: AppComponent) {
      this.user = this.service.user;
      if (this.user.business && this.user.business.length) {
         this.businessEtax = this.user.business.filter( item => item.status === 'A' || item.status === 'E' );
         if (this.businessEtax.length > 0) {
            this.company = this.businessEtax[0].tin;
            this.status = this.businessEtax[0].status;
         }
      }
      this.th = this.translate.currentLang === 'th';
   }

   ngOnInit(): void {
      this.service.checkQuotaTask()
         .subscribe(data => {
            this.countTask = data.countTasks;
            this.quotaTask = data.profile.quotaTask;
            if (data.profile.quotaTask === 0) {
               this.unlimitTask = true;
               this.taskPercent = 0;
            } else {
               if(data.profile.quotaTask < 10 && this.user.business){
                  this.quotaTask = 10;
               }
               this.taskPercent = (data.countTasks /this.quotaTask) * 100;
            }
            if(this.taskPercent >= 80){
               this.taskColor = 'warn';
            } else if(this.taskPercent >= 50){
               this.taskColor = 'accent';
            }
         });
      if(this.user.quota <= 0||this.user.quota === undefined){
         this.unlimitSpace = true;
         this.spacePercent = 0;
      } else {
         this.spacePercent = (this.user.used / this.user.quota) * 100;
      }
      if(this.spacePercent >= 80){
         this.spaceColor = 'warn';
      } else if(this.spacePercent >= 50){
         this.spaceColor = 'accent';
      }
      if (this.company) {
         this.companyChange();
      }
      localStorage.removeItem('itemSearch');
      const token = this.service.user.token;
      this.service.getProfile()
         .subscribe((data: any) => {
            this.currentDate = new Date();
            this.fNameValue = data.fName;
            this.lNameValue = data.lName;
            this.signatureId = data.signatureId;
            this.initialId = data.initialId;
            this._isFirstSingIn = data.isFirstLogin;
            this.includeName = data.includeName;
            this.includeDate = data.includeDate;
            this.hasSignature = data.hasSignature;
            this.hasInitial = data.hasInitial;

            this.app.ndid = data.isVerifiedNdid;
            this.app.ekyc = data.isVerified;
            this.app.verifiedEkyc = data.ekycLevel;
            this.app.verifiedNdid = data.ndidLevel;
            this.isAcceptEkyc = data.isConsentEKyc;
            this.isAcceptNdid = data.isConsentNdid;

            if (data.hasSignature) {
               const url = this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=' + this.includeName + '&isChkDate=' + this.includeDate + '&init=false';
               this.service.toDataURL(url, (dataUrl) => {
                  document.getElementById('signatureDdShow').setAttribute('src', dataUrl);
                  this.initialSignature();
               });
            } else {
               document.getElementById('signatureDdShow').setAttribute('src', 'assets/images/no_signature.png');
            }

            if (data.hasInitial) {
               const url = this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=false&isChkDate=false&init=true';
               this.service.toDataURL(url, function(dataUrl) {
                  document.getElementById('initDdShow').setAttribute('src', dataUrl);
               });
            } else {
               document.getElementById('initDdShow').setAttribute('src', 'assets/images/no_initials.png');
            }

            this.consentPdpa();

         }, error => {
            this.errorMessage = error;
         });

      this.getSummaryTasks();
   }

   consentPdpa() {
      this.service.consentPdpa()
         .subscribe((res) => {
            const data = res;
            const isConsentEkyc = this.isAcceptEkyc && !data.consentEkyc;
            const isConsentNdid = this.isAcceptNdid && !data.consentNdid;

            if (!data.consentPdpa || isConsentEkyc || isConsentNdid) {
               this.openPdpaDialogComponent(data, isConsentEkyc, isConsentNdid);
            } else {
               if (localStorage.getItem('first_dashboard_open') !== 'true') {
                  setTimeout(() => {
                     this.onStartTutorial();
                     localStorage.setItem('first_dashboard_open', 'true');
                  }, 1000);
               }
            }
         }, error => {
            this.errorMessage = error;
         });
   }

   prevMonth(dateObj) {
      const tempDateObj = new Date(dateObj);

      if (tempDateObj.getMonth() > 0) {
         tempDateObj.setMonth(tempDateObj.getMonth() - 1);
      } else {
         tempDateObj.setFullYear(tempDateObj.getFullYear() - 1);
         tempDateObj.setMonth(11);
      }

      return tempDateObj;
   }

   getSummaryTasks() {
      const d = new Date();
      const prevDate = this.prevMonth(d);
      const fromDate = prevDate.getFullYear() + '-' + (prevDate.getMonth() + 1) + '-01';
      const toDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();

      this.service.listInboxSummary(fromDate + ' 00:00:00', toDate + ' 23:59:59')
         .subscribe((data) => {
            this.sumNeedSign = data.actionRequired;
            this.sumWaitOther = data.waitingForOthers;
            this.sumSignedDoc = data.documentSigned;
         }, error => {
            this.errorMessage = error;
         });
   }

   editSignature(type): void {
      const registerSignDialog = this.dialog.open(RegisterSignatureComponent, {
         disableClose: true,
         data: this,
         autoFocus: false
      });
      if(type === 'Signature'){
         registerSignDialog.componentInstance.selectPatternStyle = 'Singnature' ;
      } else if(type === 'Initials'){
         registerSignDialog.componentInstance.selectPatternStyle = 'InitializeSign' ;
      }
      this.imageSignaturePreview = document.getElementById('signatureDdShow').getAttribute('src');
      this.imageInitializePreview = document.getElementById('initDdShow').getAttribute('src');
      registerSignDialog.componentInstance.signatureId = this.signatureId;
      registerSignDialog.componentInstance.initialId = this.initialId;
      registerSignDialog.componentInstance.imageSignatureOriginal = this.imageSignaturePreview;
      registerSignDialog.componentInstance.imageInitOriginal = this.imageInitializePreview;
      registerSignDialog.componentInstance.fullNameValue = this.service.user.name;
      registerSignDialog.componentInstance.includeName = this.includeName;
      registerSignDialog.componentInstance.includeDate = this.includeDate;
      registerSignDialog.componentInstance.hasSignature = this.hasSignature;
      registerSignDialog.componentInstance.hasInitial = this.hasInitial;
      registerSignDialog.afterClosed().subscribe(result => {
         if (result) {
            this.includeName = registerSignDialog.componentInstance.includeName;
            this.includeDate = registerSignDialog.componentInstance.includeDate;
            this.hasSignature = true;
            this.hasInitial = true;
            const url = this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=' + this.includeName + '&isChkDate=' + this.includeDate + '&init=false';
            this.service.toDataURL(url, (dataUrl) => {
               document.getElementById('signatureDdShow').setAttribute('src', dataUrl);
               this.imageSignaturePreview = document.getElementById('signatureDdShow').getAttribute('src');
               this.initialSignature();
            });
            const urlinit = this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=false&isChkDate=false&init=true';
            this.service.toDataURL(urlinit, function(dataUrl) {
               document.getElementById('initDdShow').setAttribute('src', dataUrl);
            });
            this.imageInitializePreview = document.getElementById('initDdShow').getAttribute('src');
         }
      });
   }

   initialSignature(){
      let img = document.getElementById('signatureDdShow');
      let imgTmp = new Image();
      // img2.width = 200;
      // img2.width = 50;
      imgTmp.onload = () => {
         let canvas = this.canvasOriginal.nativeElement;
         let context = canvas.getContext("2d");
         var hRatio = canvas.width / imgTmp.width;
         var vRatio = canvas.height / imgTmp.height;
         var ratio = Math.min(hRatio, vRatio);
         var centerShiftX = ( canvas.width - imgTmp.width*ratio ) / 2;
         var centerShiftY = ( canvas.height - imgTmp.height*ratio ) / 2;
         context.clearRect(0, 0, canvas.width, canvas.height);
         context.drawImage(imgTmp,0,0, imgTmp.width, imgTmp.height, centerShiftX, centerShiftY,
            (imgTmp.width) * ratio, imgTmp.height * ratio);
         const tmp = this.editPatternCanvas(this.canvasOriginal.nativeElement, 'original');

         document.getElementById('signatureDdShow').setAttribute('src', tmp.toDataURL());
         this.imageSignaturePreview = tmp.toDataURL();
      }
      imgTmp.src =img.getAttribute('src');
   }

   editPatternCanvas(oldCanvas: HTMLCanvasElement , type: string) {
      let canvasTmp = this.canvasPatternTmp.nativeElement;
      const ctx = canvasTmp.getContext('2d');
      ctx.clearRect(0, 0, canvasTmp.width, canvasTmp.height);

      if ((this.includeName || this.includeDate) && type !== 'init') {
         canvasTmp.width = oldCanvas.width + 75;
         canvasTmp.height = oldCanvas.height;

         ctx.drawImage(oldCanvas, -10, 0);

         const datepipe: DatePipe = new DatePipe('en-US');
         const formatDate = datepipe.transform(this.currentDate, 'dd/MM/yyyy');
         const formatTime = datepipe.transform(this.currentDate,  'HH:mm:ss Z');

         ctx.font = '200 8px Arial';
         const width = ctx.measureText(formatDate + ' ' + formatTime).width - 10;

         const x = canvasTmp.width - width;
         let y = canvasTmp.height / 2;
         if (this.includeName && this.includeDate) {
            y -= 10;
         }

         const lineSpace = 8;

         this.fillIncludeText(ctx, x, y, lineSpace, formatDate, formatTime);
      } else {
         canvasTmp.width = oldCanvas.width;
         canvasTmp.height = oldCanvas.height;
         ctx.drawImage(oldCanvas, 0, 0);
      }
      return canvasTmp;
  }

  fillIncludeText(ctx: any, x: number, y: number, lineSpace: number, date: string, time: string) {
      const user = JSON.parse(localStorage.getItem('idex-user'));
      if (this.includeName) {
         ctx.fillText('Digital signed by', x, y);
         y = y + lineSpace;
         let limit = 19;
         if (user.name.length <= limit) {
            ctx.fillText(user.name, x, y);
            y = y + lineSpace;
         } else {
            let len = user.name.length;
            let startIndex = 0;
            let endIndex = len - 1;
            while(startIndex <= endIndex){
               let str = user.name.substring(startIndex,startIndex + limit);
               startIndex += limit;
               ctx.fillText(str, x, y);
               y = y + lineSpace;
            }
         }
      }
      if (this.includeDate) {
         ctx.fillText('Date: ' + date, x, y);
         y = y +  lineSpace;
         ctx.fillText(time, x, y);
      }
   }

   openNewTask() {
      this.router.navigate(['/create-task']);
   }

   private loadDashboard() {
      this.service.get('/work/' + this.company + '/dashboard').subscribe(data => {
         this.year = data.year;
         this.year_param = { year: this.th ? this.year + 543 : this.year };
         this.sell = data.sell;
         this.buy = data.buy;
         this.calcSpaceUsage(data.used, data.quota);
         this.displayPieChart(data.document);
      });
   }

   private calcSpaceUsage(used: number, quota: number): void {
      this.used = used;
      this.quota = quota;
      this.percentUsed = Math.round(used * 100 / quota) + '%';
   }

   private displayPieChart(document: any) {
      if (this.pieChart) {
         this.pieChart.destroy();
      }
      let title;
      this.translate.get('dashboard.total_title', {year: this.th ? this.year + 543 : this.year}).subscribe((res: string) => {
         title = res;
      });
      const config = {
         type: 'doughnut',
         data: {
            datasets: [{
               data: [
                  document.INV,
                  document.RCPT,
                  document.CIV,
                  // document.NIV,
                  document.DBN,
                  document.CRN
               ],
               backgroundColor: [
                  Chart.helpers.color('#2AB4C0').rgbString(),
                  Chart.helpers.color('#4285F4').rgbString(),
                  Chart.helpers.color('#EA4335').rgbString(),
                  Chart.helpers.color('#ffa726').rgbString(),
                  Chart.helpers.color('#34A853').rgbString()
               ],
               borderWidth: [1, 1, 1, 1, 1],
               hoverBorderColor: ['#00bcd4', '#00bcd4', '#00bcd4', '#ffa726', '#ffa726']
            }],
            labels: this.th ?
               [
                  'ใบกำกับภาษี',
                  'ใบเสร็จรับเงิน',
                  'ยกเลิกใบกำกับภาษี',
                  // 'ออกใบกำกับภาษีใหม่',
                  'ใบเพิ่มหนี้',
                  'ใบลดหนี้',
               ] :
               [
                  'Tax Invoice',
                  'Receipt',
                  'Cancellation Note',
                  // 'ออกใบกำกับภาษีใหม่',
                  'Debit Note',
                  'Credit Note',
               ]
         },
         options: {
            cutoutPercentage: 60,
            title: {
               display: false,
               fontSize: 16,
               text: title
            },
            legend: {
               position: 'bottom',
               labels: {
                  usePointStyle: true
               }
            }
         }
      };
      this.pieChart = new Chart('type', config);
      this.pieChart = new Chart('type-mobile', config);
   }

   private loadTransactions() {
      this.service.get('/work/' + this.company + '/transactions')
         .subscribe(data => {
            this.displayTransactions(data);
            this.transactionsLoaded = true;
         });
   }

   private displayTransactions(data: any) {
      if (this.lineChart) {
         this.lineChart.destroy();
      }
      let month;
      let quantity;
      const title = '';
      this.translate.get('dashboard.month').subscribe(s => month = s);
      this.translate.get('dashboard.quantity').subscribe(s => quantity = s);
      const config = {
         type: 'line',
         data: {
            labels: this.th ?
               ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'] :
               ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [{
               label: this.th ? (data.lastyear.year + 543) : data.lastyear.year,
               fill: false,
               backgroundColor: '#ffa726',
               borderColor: '#ffa726',
               borderDash: [2, 4],
               borderWidth: 2,
               pointRadius: 2,
               data: data.lastyear.items
            },
               {
                  label: this.th ? (data.thisyear.year + 543) : data.thisyear.year,
                  fill: false,
                  backgroundColor: '#2AB4C0',
                  borderColor: '#2AB4C0',
                  borderWidth: 2,
                  pointRadius: 4,
                  data: data.thisyear.items
               }]
         },
         options: {
            responsive: true,
            title: {
               display: false,
               fontSize: 16,
               text: title
            },
            legend: {
               labels: {
                  boxWidth: 20
               }
            },
            elements: {
               line: {tension: 0}
            },
            tooltips: {
               mode: 'index',
               intersect: false,
            },
            hover: {
               mode: 'nearest',
               intersect: true
            },
            scales: {
               xAxes: [{
                  display: true,
                  scaleLabel: {
                     display: true,
                     labelString: month
                  }
               }],
               yAxes: [{
                  display: true,
                  scaleLabel: {
                     display: true,
                     labelString: quantity
                  },
                  ticks: {
                     beginAtZero: true,
                     // stepSize: 1
                     userCallback: function (label, index, labels) {
                        if (Math.floor(label) === label) {
                           return label;
                        }

                     },
                  }
               }]
            }
         }
      };
      this.lineChart = new Chart('usage', config);
   }

   openFilter(button: any, type: any, company: any) {
      button.disabled = true;
      const tin = company.selected.value;
      this.service.get('/report/month/' + tin + '/' + type + '/')
         .subscribe(data => {
            button.disabled = false;
            this.data_year = data.listYear;
            this.dialog.open(MonthlySummaryComponent, {
               disableClose: true,
               data: {type: type, tin: tin, years: this.data_year, th: this.th}
            });
         }, () => {
            button.disabled = false;
         });
   }

   openEtaxByEmail(): void {
      const etaxInvoice = this.dialog.open(RegisterEtaxComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('register_dashboard_title').subscribe((msg) => {
         etaxInvoice.componentInstance.title = msg;
      });
   }

   openRegisterCompany(): void {
      const etaxInvoice = this.dialog.open(RegisterCompanyDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('register_dashboard_company').subscribe((msg) => {
         etaxInvoice.componentInstance.title = msg;
      });
   }

   companyChange() {
      this.transactionsLoaded = false;
      this.used = undefined;
      this.quota = undefined;
      this.loadDashboard();
      this.loadTransactions();
   }

   formatCurrency(value) {
      return this.numeral.transform(value, '0,0.00');
   }

   onStartTutorial(): void {
      this.translate.get('tutorial').subscribe((msg) => {
         const enjoyhint_instance = new EnjoyHint({});
         const enjoyhint_script_steps = [
            {
               'click #apps-button-hint': msg.dashboard.appsMenu,
               'skipButton': {text: msg.close}
            },
            {
               'next #dashboard-hint': msg.dashboard.dashboardMenu,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close}
            },
            {
               'next #cabinet-hint': msg.dashboard.documentMenu,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close}
            },
            {
               'next #sign-hint': msg.dashboard.signMenu,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close}
            },
            {
               'next .etax': msg.dashboard.registerEtax,
               'nextButton': { text: msg.next },
               'skipButton': { text: msg.close },
               onBeforeStart: function () {
                  document.getElementById('apps-button-hint').click();
               }
            },
            {
               'click #profile-hint': msg.dashboard.profileMenu,
               'skipButton': {text: msg.close},
               shape: 'circle'
            },
            {
               'click #update-profile-hint': msg.dashboard.updateProfile,
               'skipButton': {text: msg.close}
            }
         ];
         enjoyhint_instance.set(enjoyhint_script_steps);
         enjoyhint_instance.run();
      });
   }

   openPdpaDialogComponent(data: any, isConsentEkyc: boolean, isConsentNdid: boolean) {
      const pdpaDialog = this.dialog.open(PdpaAgreementComponent, {
         disableClose: true,
         data: { isRegister: false, isConsent: !data.consentPdpa, isConsentEkyc: isConsentEkyc, isConsentNdid: isConsentNdid }
      });
      pdpaDialog.afterClosed().subscribe(result => {
         if(result){
            if (localStorage.getItem('first_dashboard_open') !== 'true') {
               setTimeout(() => {
                  this.onStartTutorial();
                  localStorage.setItem('first_dashboard_open', 'true');
               }, 1000);
            }
         }

      });
   }
}
